module.exports = __webpack_public_path__ + "static/media/pd-intro.afccd52f.mp3";